import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-equipment-grid',
  templateUrl: './project-equipment-grid.component.html',
  styleUrls: ['./project-equipment-grid.component.css']
})
export class ProjectEquipmentGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
